<ngx-simplebar class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
    [options]="{ forceVisible: true }">
    <form [formGroup]="propertyCharateristicsForm" #formElementRef class="char-picker" [class.is-readonly]="readonly">

        <!-- Barra: pesquisa global + filtros + contador -->
        <div class="char-picker-toolbar">
            <div class="search-box flex-grow-1">
                <input type="text" class="form-control" [ngModel]="searchTerm" (ngModelChange)="onSearch($event)"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="{{'t-characteristics-picker.t-search-placeholder' | translate}}">
                <i class="ri-search-line search-icon"></i>
            </div>
            <div class="char-picker-filters">
                <button type="button" class="char-filter" [class.is-active]="filter === 'all'" (click)="setFilter('all')">
                    {{'t-characteristics-picker.t-filter-all' | translate}}
                </button>
                <button type="button" class="char-filter" [class.is-active]="filter === 'selected'" (click)="setFilter('selected')">
                    {{'t-characteristics-picker.t-filter-selected' | translate}}
                    <span class="char-filter-count" *ngIf="selectedCount > 0">{{selectedCount}}</span>
                </button>
                <button type="button" class="char-filter" [class.is-active]="filter === 'unfilled'" (click)="setFilter('unfilled')">
                    {{'t-characteristics-picker.t-filter-unfilled' | translate}}
                </button>
                <button type="button" class="char-filter" [class.is-active]="filter === 'featured'" (click)="setFilter('featured')">
                    <i class="ri-star-line"></i> {{'t-characteristics-picker.t-filter-featured' | translate}}
                </button>
            </div>
            <div class="char-picker-summary">
                <span class="char-summary-pill" [class.has-selection]="selectedCount > 0">
                    <i class="ri-checkbox-circle-line"></i>
                    {{'t-characteristics-picker.t-selected-count' | translate: {count: selectedCount} }}
                </span>
                <button type="button" class="btn btn-link btn-sm p-0 ms-2" *ngIf="selectedCount > 0 && !readonly" (click)="clearAll()">
                    {{'t-characteristics-picker.t-clear' | translate}}
                </button>
            </div>
        </div>

        <div class="char-picker-body">
            <!-- Navegação por grupo -->
            <aside class="char-picker-nav">
                <button type="button" class="char-nav-item" *ngFor="let v of view; trackBy: trackGroup"
                    [class.is-active]="activeGroupId === v.group.id" (click)="scrollTo(v.group.id)">
                    <span class="char-nav-icon"><i class="{{v.group.icon || 'ri-price-tag-3-line'}}"></i></span>
                    <span class="char-nav-label">{{v.group.description}}</span>
                    <span class="char-nav-count" [class.has-selection]="v.selected > 0">{{v.selected}}/{{v.total}}</span>
                </button>
            </aside>

            <!-- Secções -->
            <div class="char-picker-sections">
                <p class="text-muted small mb-3" *ngIf="hiddenByTypeCount > 0 && filter === 'all' && !searchTerm">
                    <i class="ri-information-line align-middle"></i>
                    {{'t-characteristics-picker.t-not-applicable-hint' | translate}}
                </p>
                <div class="char-picker-empty" *ngIf="view.length === 0">
                    <i class="ri-search-eye-line"></i>
                    <span>{{'t-characteristics-picker.t-no-results' | translate}}</span>
                </div>

                <section class="char-group" *ngFor="let v of view; trackBy: trackGroup" id="char-group-{{v.group.id}}">
                    <header class="char-group-header">
                        <div class="char-group-heading">
                            <span class="char-group-icon"><i class="{{v.group.icon || 'ri-price-tag-3-line'}}"></i></span>
                            <div>
                                <h6 class="char-group-title">{{v.group.description}}</h6>
                                <p class="char-group-subtitle">
                                    {{'t-characteristics-picker.t-options-count' | translate: {count: v.total} }}
                                    · {{('t-characteristics-picker.t-hint-' + v.hint) | translate}}
                                </p>
                            </div>
                        </div>
                        <span class="char-group-progress" [class.has-selection]="v.selected > 0">{{v.selected}}/{{v.total}}</span>
                    </header>

                    <div class="char-grid">
                        <div class="char-card" *ngFor="let item of v.items; trackBy: trackItem"
                            [class.is-selected]="isSelected(item)" [class.is-number]="item.valueType === 'NUMBER'"
                            [attr.data-control]="item.control">

                            <div class="char-card-row">
                                <button type="button" class="char-card-main" [disabled]="readonly" (click)="toggle(item)">
                                    <span class="char-card-box">
                                        <i class="ri-check-line char-card-check"></i>
                                        <i *ngIf="item.icon" class="{{item.icon}} char-card-icon"></i>
                                    </span>
                                    <span class="char-card-label">{{item.description}}</span>
                                    <i class="ri-star-fill char-card-star" *ngIf="item.isFeatured"></i>
                                </button>

                                <!-- Quantidade: stepper sempre visível, 0 = não tem -->
                                <div class="char-stepper" *ngIf="item.valueType === 'NUMBER'">
                                    <button type="button" class="char-stepper-btn" [disabled]="readonly || !isSelected(item)" (click)="step(item, -1, $event)"><i class="ri-subtract-line"></i></button>
                                    <input type="number" class="char-stepper-input" [value]="valueOf(item) ?? 0" [min]="0"
                                        [max]="item.maxValue" [readonly]="readonly" (change)="setNumber(item, $any($event.target).value)">
                                    <button type="button" class="char-stepper-btn" [disabled]="readonly" (click)="step(item, 1, $event)"><i class="ri-add-line"></i></button>
                                    <span class="char-stepper-unit" *ngIf="item.unit">{{item.unit}}</span>
                                </div>
                            </div>

                            <!-- Opção única -->
                            <div class="char-options" *ngIf="item.valueType === 'SELECT' && isSelected(item)">
                                <button type="button" class="char-option" *ngFor="let option of item.options; trackBy: trackOption"
                                    [class.is-active]="valueOf(item) === option.key" [disabled]="readonly"
                                    (click)="chooseOption(item, option.key, $event)">{{option.label}}</button>
                            </div>
                        </div>
                    </div>

                    <button type="button" class="char-show-more" *ngIf="v.hidden > 0 || v.expanded"
                        (click)="toggleExpanded(v.group.id)">
                        <ng-container *ngIf="!v.expanded"><i class="ri-arrow-down-s-line"></i> {{'t-characteristics-picker.t-show-more' | translate: {count: v.hidden} }}</ng-container>
                        <ng-container *ngIf="v.expanded"><i class="ri-arrow-up-s-line"></i> {{'t-characteristics-picker.t-show-less' | translate}}</ng-container>
                    </button>
                </section>
            </div>
        </div>
    </form>
</ngx-simplebar>
